module.exports = __webpack_public_path__ + "img/mb_footer_bg.a58fe0f.webp";